import { render, staticRenderFns } from "./visual-shelf.vue?vue&type=template&id=044450e6"
import script from "./visual-shelf.vue?vue&type=script&lang=js"
export * from "./visual-shelf.vue?vue&type=script&lang=js"
import style0 from "./visual-shelf.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports